interface LogoIconProps {
  color: string;
  width?: number;
  height?: number;
}

const LogoIcon = ({ color = 'white', width = 21, height = 21 }: LogoIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9498 2.15625L9.70638 5.40194L11.0896 6.78612L12.9498 4.94849L17.8149 9.81702L10.5649 17.0482L9.63484 16.1413L2.79029 9.29198L6.05754 6.02243L10.9465 10.9387L12.3536 9.5545L6.05754 3.23019L0 9.29198L8.25162 17.5494L10.5649 19.8405L20.5813 9.81702L12.9498 2.15625Z"
        fill={color}
      />
      <path
        d="M6.86423 8.23092L5.02612 10.0703L6.42578 11.471L8.26389 9.63156L6.86423 8.23092Z"
        fill={color}
      />
    </svg>
  );
};

export default LogoIcon;
